import {defineStore} from "pinia";

import AxiosClass from "@/classes/axios.js";
import General from "@/classes/general.js";
const axiosConstant = new AxiosClass();
const general = new General();

export const useConstantStore = defineStore('constants', {
    state: () => ({
        listOfConstants: [],
        constantVersion: null,
        constantNeedRefresh: false,
        historyRateKm: [],
        historyKmVersion: null,
        historyKmNeedRefresh: false
    }),
    getters: {

    },
    actions: {
        async load({
            refreshConstant = false, 
            refreshHistoryKm = false
        } = {}) {
            if (refreshConstant) {
                await this.getConstants(this.constantNeedRefresh);
            }
            if (refreshHistoryKm) {
                await this.getHistoryRateKm(this.historyKmNeedRefresh);
            }
        },
        async getConstants(forceRefresh = false) {
            if (!forceRefresh && this.listOfConstants.length > 0) return false;

            await axiosConstant.get('/ConstantList').then((data) => {
                if (data !== undefined) {
                    this.listOfConstants = data;
                }
            });

            await axiosConstant.get('/VersioningByType/constant').then((data) => {
                this.constantVersion = data;
            });

            this.constantNeedRefresh = false;

            return true;
        },
        needRefresh(flag, versionField, version) {
            this[flag] = (version.original.version_number > this[versionField]);
            return this[flag];
        },
        getConstantByVariable(varName) {
            if (this.listOfConstants.length > 0)
                return { ...this.listOfConstants.find(constant => constant.variable === varName)};
            else
                return [{value: null}];
        },
        async getHistoryRateKm(forceRefresh = false) {
            if (!forceRefresh && this.historyRateKm.length > 0) return false;

            await axiosConstant.get('/HistoryRateKm').then((data) => {
                if (data !== undefined) {
                    this.historyRateKm = data;
                }
            });

            await axiosConstant.get('/VersioningByType/historyRateKm').then((data) => {
                this.historyKmVersion = data;
            });

            this.historyKmNeedRefresh = false;

            return true;
        },
        getHistoryRateKmByDate(date) {
            let historySize = this.historyRateKm.length;

            for (let i = 0; i < historySize; i++) {
                if (i < historySize-1 && general.isDateBetween(date, this.historyRateKm[i].date, this.historyRateKm[i + 1].date, '[)'))
                    return {'cost': this.historyRateKm[i].cost, 'sell': this.historyRateKm[i].sell};
            }

            return {'cost': this.historyRateKm[historySize - 1].cost, 'sell': this.historyRateKm[historySize - 1].sell};
        },
        clear () {
            this.$reset();
        },
        async save(variable){
            let returnValue = false;

            await axiosConstant.post('/ConstantSave', {constant: variable}).then((response) => {                
                if (Object.keys(response).length > 0) {
                    this.setConstant(response);
                    returnValue = true;
                }
            });
            return returnValue;
        },
        setConstant(constant) {
            let index = this.listOfConstants.findIndex(c => c.variable === constant.variable);
            this.listOfConstants[index] = { ...constant};
        },  
    },
    persist: {
        storage: sessionStorage,
        paths: ['listOfConstants', 'constantVersion', 'historyRateKm', 'historyKmVersion'],
    },
})